import { JsonObject, JsonProperty } from 'json2typescript';
import { Contact } from '../clients/contact';

export enum ContactTypeEnum {
    CASE_HEARING = 1,
    EXPERT_HEARING = 2,
    FINANCIAL = 3
}

@JsonObject('CaseClientContact')
export class CaseClientContact {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('contact', Contact, true)
    contact: Contact = null;

    @JsonProperty('is_case_hearing', Boolean, true)
    isCaseHearing = false;

    @JsonProperty('is_expert_hearing', Boolean, true)
    isExpertHearing = false;

    @JsonProperty('is_financial', Boolean, true)
    isFinancial = false;

    // write data
    @JsonProperty('case_id', Number, true)
    caseId: number = undefined;

    @JsonProperty('contact_id', Number, true)
    contactId: number = undefined;

    get name() {
        return this.contact.fullName;
    }

    get contactTypeStr() {
        const types = []
        if (this.isCaseHearing) types.push('Court Hearings Contact');
        if (this.isExpertHearing) types.push('Expert Sessions Contact');
        if (this.isFinancial) types.push('Financial Contact');
        return types.join(', ');
    }
}